// Import api models.
import {
	PerilDeductible,
} from '@app/models/api';
// Import enumerations.
import {
	Peril,
} from '@app/enumerations';

interface ComparisonSummaryPerilDeductibleParameters {
	perilCode: Peril;
	oldSelectedPerilDeductible?: PerilDeductible;
	newSelectedPerilDeductible?: PerilDeductible;
}

export default class ComparisonSummaryPerilDeductible {

	public perilCode: Peril;
	public oldSelectedPerilDeductible?: PerilDeductible;
	public newSelectedPerilDeductible?: PerilDeductible;

	public constructor(params: ComparisonSummaryPerilDeductibleParameters) {
		this.perilCode = params.perilCode;
		this.oldSelectedPerilDeductible = params.oldSelectedPerilDeductible;
		this.newSelectedPerilDeductible = params.newSelectedPerilDeductible;
	}

}